export enum MARCAS {
    SUPERDEPORTE_MARCA = 'Superdeporte S.A.',
    MEDEPORT_REEBOK_MARCA = 'Mundo Deportivo Medeport S.A. - REEBOK',
    MEDEPORT_ADIDAS_MARCA = 'Mundo Deportivo Medeport S.A. - ADIDAS',
    EQUINOX_MARCA = 'Equinox Ecuador S.A.',
}
    